export const LOGIN = '/';
export const HOME = '/app';
export const RECOVER_PASSWORD = '/auth/recovery/:token';
export const STORES = '/stores';
